import { render } from "./ReportDatePresets.vue?vue&type=template&id=2ad4d4d7&scoped=true"
import script from "./ReportDatePresets.vue?vue&type=script&lang=js"
export * from "./ReportDatePresets.vue?vue&type=script&lang=js"

import "./ReportDatePresets.vue?vue&type=style&index=0&id=2ad4d4d7&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ad4d4d7"]])

export default __exports__